import 'react-image-crop/dist/ReactCrop.css';

import { FC, useEffect, useState } from 'react';
import { Step1, Step2, Step3 } from './components';

import { IWebcamImageProps } from './models/IWebcamImageProps';
import clsx from 'clsx';

export const WebcamImage: FC<IWebcamImageProps> = ({ className }) => {
  const [imageSrc, setImageSrc] = useState<string>();
  const [finalImageSrc, setFinalImageSrc] = useState<string>();
  const [step, setStep] = useState<number>(1)

  useEffect(() => {
    console.log(finalImageSrc)
  },[finalImageSrc])
  
  return (
    <div className={clsx(className, 'd-flex flex-row gap-5 align-items-center')}>
      {(step === 1) && <Step1 setImage={setImageSrc} moveNext={() => setStep(2)} />}
      {(step === 2) && <Step2 image={imageSrc!} setImage={setFinalImageSrc} moveNext={() => setStep(3)} moveBack={() => setStep(1)} />}
      {(step === 3) && <Step3 image={finalImageSrc!} moveBack={() => setStep(2)} />}
    </div>
  );
}